import { FormHelperText, Stack } from "@mui/material";
import { useState } from "react";
import FilesDropArea from "@entrilia/shared/components/FilesDropArea";
import { formatFileSize } from "@entrilia/shared/utilities/fileHelper";
import { fileToUploadValidator } from "@entrilia/shared/utilities/validators";

interface Props {
  onFileUpload: (file: File) => void;
}

const acceptedFileExtensions = [".pdf", ".jpg", ".jpeg", ".png", ".tif", ".tiff"];

const maxFileSize = 25_000_000; // 25 MB

const subtitle = `Maximum file size: ${formatFileSize(maxFileSize)}. Supported formats: PDF and image files.`;

const ObjectCardDocumentUploadArea = ({ onFileUpload }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string>();

  const handleFilesAdd = (files: File[]) => {
    const file = files[0];
    if (!file) {
      return;
    }

    const validationResult = fileToUploadValidator({ maxFileSize, acceptedFileExtensions })(file);
    if (!validationResult.isValid) {
      setErrorMessage(validationResult.error);
      return;
    }

    setErrorMessage(undefined);
    onFileUpload(file);
  };

  return (
    <>
      <Stack spacing={1} sx={{ height: "100%", px: 2, pb: 2 }}>
        {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}

        <FilesDropArea
          acceptedFileExtensions={acceptedFileExtensions}
          subtitle={subtitle}
          onFilesAdd={handleFilesAdd}
          containerProps={{ sx: { height: "100%" } }}
        />
      </Stack>
    </>
  );
};

export default ObjectCardDocumentUploadArea;
